import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-not-found',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="not-found-container d-flex align-items-start pt-5 justify-content-center min-vh-100 bg-light">
      <div class="card shadow-sm border-0" style="max-width: 500px;">
        <div class="card-body p-4 p-sm-5">
          <div class="text-center mb-4">
            <div class="mb-3">
              <i class="bi bi-exclamation-triangle fs-1 text-warning"></i>
            </div>
            <h1 class="fw-bold">404</h1>
            <h3 class="mb-4">Page Not Found</h3>
            <p class="text-secondary mb-4">We couldn't find the page you were looking for. The page may have been moved, deleted, or never existed.</p>
          </div>

          <div class="d-grid gap-2">
            <a [href]="catalogMyQuizzesUrl" class="btn btn-primary">Go to your Quizzes</a>
          </div>
        </div>
      </div>
    </div>
  `
})
export class NotFoundComponent {
  catalogMyQuizzesUrl = `${environment.catalogUrl}/my-quizzes`;
}
